var map = {
	"./featured-item/coach@3x.webp": 169,
	"./featured-item/cuff@3x.webp": 173,
	"./featured-item/fastclix_lancets@3x.webp": 177,
	"./featured-item/fastclix_lancing_kit@3x.webp": 181,
	"./featured-item/guide@3x.webp": 185,
	"./featured-item/guide_me@3x.webp": 189,
	"./featured-item/mysugr_coach_voucher_based_1@3x.webp": 193,
	"./featured-item/pro@3x.webp": 197,
	"./featured-item/scale@3x.webp": 201,
	"./featured-item/softclix_lancets@3x.webp": 205,
	"./featured-item/softclix_lancing_kit@3x.webp": 209,
	"./featured-item/strips_subscription_guide@3x.webp": 213,
	"./item/coach@3x.webp": 295,
	"./item/cuff@3x.webp": 297,
	"./item/fastclix_lancets@3x.webp": 299,
	"./item/fastclix_lancing_kit@3x.webp": 301,
	"./item/guide@3x.webp": 303,
	"./item/guide_me@3x.webp": 305,
	"./item/guide_strips@3x.webp": 307,
	"./item/mysugr_coach_voucher_based_1@3x.webp": 309,
	"./item/pro@3x.webp": 311,
	"./item/scale@3x.webp": 313,
	"./item/softclix_lancets@3x.webp": 315,
	"./item/softclix_lancing_kit@3x.webp": 317,
	"./item/strips_subscription_guide@3x.webp": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 686;